import { Navigate, Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { useAuth } from './lib/AuthContext'
import { AuthPage, ResetPasswordPage } from './pages/AuthPage'
import { DashboardPage } from './pages/DashboardPage'
import { AccountFormPage } from './pages/AccountFormPage'
import { AccountsPage } from './pages/AccountsPage'
import { CardFormPage } from './pages/CardFormPage'
import { CardsPage } from './pages/CardsPage'
import { UsersPage } from './pages/UsersPage'
import { MetropolitanSchedulePage } from './pages/MetropolitanSchedulePage'
import { RegistrationManagementPage } from './pages/RegistrationManagementPage'
import { BankIntegrationsPage } from './pages/BankIntegrationsPage'

export function App() {
  const { user, profile, loading } = useAuth()
  if (loading) return <div className="splash"><div className="spinner" /><p>Carregando financeiro…</p></div>

  return <Routes>
    <Route path="/login" element={user ? <Navigate to="/" replace /> : <AuthPage />} />
    <Route path="/reset-password" element={<ResetPasswordPage />} />
    <Route path="/*" element={!user ? <Navigate to="/login" replace /> : profile?.status !== 'active' ? <AccessPending /> : <ProtectedRoutes />} />
  </Routes>
}

function ProtectedRoutes() {
  const { profile } = useAuth()
  const admin = profile?.role === 'admin'
  return <Routes><Route element={<Layout />}>
    <Route index element={<DashboardPage />} />
    <Route path="contas-a-pagar" element={<AccountsPage />} />
    <Route path="cartao-roly" element={<CardsPage />} />
    <Route path="cronograma-clientes" element={<MetropolitanSchedulePage />} />
    <Route path="gestao-cadastros-metropolitan" element={<RegistrationManagementPage />} />
    <Route path="integracoes-bancarias" element={admin ? <BankIntegrationsPage /> : <Navigate to="/" />} />
    <Route path="cadastro-conta" element={admin ? <AccountFormPage /> : <Navigate to="/" />} />
    <Route path="cadastro-cartao-roly" element={admin ? <CardFormPage /> : <Navigate to="/" />} />
    <Route path="gestao-emails" element={admin ? <UsersPage /> : <Navigate to="/" />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Route></Routes>
}

function AccessPending() {
  const { profile, signOut, refreshProfile } = useAuth()
  const blocked = profile?.status === 'blocked'
  return <div className="auth-shell"><section className="auth-card centered">
    <div className="brand-mark large">FR</div>
    <h1>{blocked ? 'Acesso bloqueado' : 'Cadastro aguardando liberação'}</h1>
    <p>{blocked ? 'Seu acesso foi bloqueado por um administrador.' : 'Seu usuário foi criado. Um administrador precisa liberar o acesso ao sistema.'}</p>
    <button onClick={refreshProfile}>Verificar novamente</button>
    <button className="secondary" onClick={signOut}>Sair</button>
  </section></div>
}
